import { Box, Typography } from '@branch-messenger/willow-ui'
import { InfoCircleFilled } from '@branch-messenger/willow-ui/icons'
import { FC } from 'react'

import { TaxUpdateErrorIcon } from './styles'

type Props = {
  title: string
  description: string
}

export const TaxUpdateError: FC<Props> = ({ title, description }) => {
  return (
    <Box
      $display="flex"
      $direction="column"
      $justify="center"
      $align="start"
      $gap={4}
    >
      <TaxUpdateErrorIcon Icon={InfoCircleFilled} />
      <Typography $size="2xl" $bold>
        {title}
      </Typography>
      <Typography $size="md">{description}</Typography>
    </Box>
  )
}
